let gtmInitialized = false;

const getTenantId = () => {
  return process.env.REACT_APP_COMPANY_NAME_ABRV || "DLC";
};

const getProductId = () => {
  return "evshopper";
};

const GaTracker = {
  initialize: () => {
    if (gtmInitialized) return;
  
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    // Initialize GTM
    const gtmId =
      process.env.REACT_APP_ENVIRONMENT === "production"
        ? process.env.REACT_APP_GA_PRODUCTION_TRACKING_GTM_ID
        : process.env.REACT_APP_GA_STAGING_TRACKING_GTM_ID;

    if (gtmId) {
      // Push gtm.start event FIRST
      window.dataLayer.push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });

      // Push tenant and product info separately
      window.dataLayer.push({
        tenant: getTenantId(),
        product: getProductId(),
      });

      // THEN load GTM script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}&l=dataLayer`;
      
      // Try both methods and log for debugging
      script.setAttribute('nonce', 'm7yvr64n3ob2ci9xdpl');
      script.nonce = 'm7yvr64n3ob2ci9xdpl';
      
      console.log('GTM Script nonce attribute:', script.getAttribute('nonce'));
      console.log('GTM Script nonce property:', script.nonce);
      console.log('GTM Script HTML:', script.outerHTML);
      
      document.head.appendChild(script);

      gtmInitialized = true;
    }
  },

  getPageName: (page) => {
    const lastCharIndex = page.length - 1;
    return page.length > 1 && page.charAt(lastCharIndex) === "/"
      ? page.substring(0, lastCharIndex)
      : page;
  },

  doHydrate: () => {
    GaTracker.initialize();
  },

  trackPage: (page, options = {}) => {
    try {
      page = GaTracker.getPageName(page);

      if (window.dataLayer) {
        window.dataLayer.push({
          event: "page_view",
          page_title: document.title,
          page_location: window.location.href,
          page_path: page,
          tenant: getTenantId(),
          product: getProductId(),
          ...options,
        });
      }
    } catch (error) {
      console.error("Failed to track page:", error);
    }
  },

  trackEvent: (categoryOrOptions, action, label, value) => {
    try {
      // Handle both object and positional parameter patterns
      let category;
      if (typeof categoryOrOptions === 'object' && categoryOrOptions !== null) {
        // Destructure from object
        ({category, action, label, value} = categoryOrOptions);
      } else {
        // Use positional parameters
        category = categoryOrOptions;
      }

      if (window.dataLayer) {
        window.dataLayer.push({
          event: action,
          event_action: action,
          event_category: category,
          event_label: label,
          event_value: value,
          tenant: getTenantId(),
          product: getProductId(),
        });
      }
    } catch (error) {
      console.error("Failed to track event:", error);
    }
  },
};

export default GaTracker;